import type React from "react";
import { type KeyboardEvent, type MouseEvent, useEffect, useRef } from "react";

interface ModalProps {
	hidden?: boolean;
	position?: "center" | "top";
	size?: "small" | "small-medium" | "medium" | "large";
	removePadding?: boolean;
	handleDismiss?: () => void;
	children: string | JSX.Element | null;
}

export const Modal = ({
	hidden = true,
	position = "center",
	size = "small",
	removePadding = false,
	handleDismiss = () => {},
	children,
}: ModalProps) => {
	const ref = useRef<HTMLDivElement | null>(null);

	const handleOutsideClick = (event: MouseEvent | KeyboardEvent) => {
		if (ref.current && !ref.current?.contains(event.target as Node)) {
			handleDismiss();
		}
	};

	useEffect(() => {
		if (!hidden) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}
	}, [hidden]);

	return (
		<div
			onClick={handleOutsideClick}
			onKeyUp={handleOutsideClick}
			className={`fixed left-0 right-0 top-0 z-50 overflow-y-auto h-full w-full bg-gray-400/80 ${
				hidden ? "hidden" : ""
			} `}
		>
			<div
				className={`relative w-full max-w-full min-h-full flex justify-center ${
					position === "top" ? "items-start" : "items-center"
				}`}
			>
				<div
					ref={ref}
					className={`bg-white w-11/12 ${removePadding ? "" : "p-4"} mx-auto my-8 rounded-md shadow-lg ${
						size === "small"
							? "sm:max-w-md"
							: size === "small-medium"
								? "sm:max-w-xl"
								: size === "medium"
									? "sm:max-w-3xl"
									: "sm:max-w-6xl"
					}`}
				>
					{children}
				</div>
			</div>
		</div>
	);
};
